import { render, staticRenderFns } from "./DynamicFormCompensation.vue?vue&type=template&id=5f6a770e&scoped=true"
import script from "./DynamicFormCompensation.vue?vue&type=script&lang=js"
export * from "./DynamicFormCompensation.vue?vue&type=script&lang=js"
import style0 from "./DynamicFormCompensation.vue?vue&type=style&index=0&id=5f6a770e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6a770e",
  null
  
)

export default component.exports